import {
  saveQuote as api,
  updateQuote as quoteUpdate,
  printCertificate,
  saveDocuments,
  sendQuotationEmail,
  emailCertificate,
  publicPolicyVerification,
  getConveyance,
  getCountries,
  getGoodsSections,
  getGoods,
  getCurrencyList,
  getDestinationTowns,
  getDestinationPorts,
  requestSelcomPayment,
  checkPaymentStatus
} from '../utils/apiService';

export const LIST_CURRENCIES = 'policy/LIST_CURRENCIES';
export const LIST_CURRENCIES_PENDING = 'policy/LIST_CURRENCIES_PENDING';
export const LIST_CURRENCIES_REJECTED = 'policy/LIST_CURRENCIES_REJECTED';
export const LIST_CURRENCIES_FULFILLED = 'policy/LIST_CURRENCIES_FULFILLED';

export const LIST_CONVEYANCE = 'policy/LIST_CONVEYANCE';
export const LIST_CONVEYANCE_PENDING = 'policy/LIST_CONVEYANCE_PENDING';
export const LIST_CONVEYANCE_REJECTED = 'policy/LIST_CONVEYANCE_REJECTED';
export const LIST_CONVEYANCE_FULFILLED = 'policy/LIST_CONVEYANCE_FULFILLED';

export const LIST_COUNTRIES = 'policy/LIST_COUNTRIES';
export const LIST_COUNTRIES_PENDING = 'policy/LIST_COUNTRIES_PENDING';
export const LIST_COUNTRIES_REJECTED = 'policy/LIST_COUNTRIES_REJECTED';
export const LIST_COUNTRIES_FULFILLED = 'policy/LIST_COUNTRIES_FULFILLED';

export const LIST_DESTINATION_TOWNS = 'policy/LIST_DESTINATION_TOWNS';
export const LIST_DESTINATION_TOWNS_PENDING =
  'policy/LIST_DESTINATION_TOWNS_PENDING';
export const LIST_DESTINATION_TOWNS_REJECTED =
  'policy/LIST_DESTINATION_TOWNS_REJECTED';
export const LIST_DESTINATION_TOWNS_FULFILLED =
  'policy/LIST_DESTINATION_TOWNS_FULFILLED';

export const LIST_DESTINATION_PORTS = 'policy/LIST_DESTINATION_PORTS';
export const LIST_DESTINATION_PORTS_PENDING =
  'policy/LIST_DESTINATION_PORTS_PENDING';
export const LIST_DESTINATION_PORTS_REJECTED =
  'policy/LIST_DESTINATION_PORTS_REJECTED';
export const LIST_DESTINATION_PORTS_FULFILLED =
  'policy/LIST_DESTINATION_PORTS_FULFILLED';

export const LIST_GOODS_SECTIONS = 'policy/LIST_GOODS_SECTIONS';
export const LIST_GOODS_SECTIONS_PENDING = 'policy/LIST_GOODS_SECTIONS_PENDING';
export const LIST_GOODS_SECTIONS_REJECTED =
  'policy/LIST_GOODS_SECTIONS_REJECTED';
export const LIST_GOODS_SECTIONS_FULFILLED =
  'policy/LIST_GOODS_SECTIONS_FULFILLED';

export const LIST_GOODS = 'policy/LIST_GOODS';
export const LIST_GOODS_PENDING = 'policy/LIST_GOODS_PENDING';
export const LIST_GOODS_REJECTED = 'policy/LIST_GOODS_REJECTED';
export const LIST_GOODS_FULFILLED = 'policy/LIST_GOODS_FULFILLED';

export const CREATE_QUOTE = 'quote/CREATE_QUOTE';
export const CREATE_QUOTE_PENDING = 'quote/CREATE_QUOTE_PENDING';
export const CREATE_QUOTE_REJECTED = 'quote/CREATE_QUOTE_REJECTED';
export const CREATE_QUOTE_FULFILLED = 'quote/CREATE_QUOTE_FULFILLED';

export const UPDATE_QUOTE = 'quote/UPDATE_QUOTE';
export const UPDATE_QUOTE_PENDING = 'quote/UPDATE_QUOTE_PENDING';
export const UPDATE_QUOTE_REJECTED = 'quote/UPDATE_QUOTE_REJECTED';
export const UPDATE_QUOTE_FUFLILLED = 'quote/UPDATE_QUOTE_FUFLILLED';

export const PRINT_CERTIFICATE = 'quote/PRINT_CERTIFICATE';
export const PRINT_CERTIFICATE_PENDING = 'quote/PRINT_CERTIFICATE_PENDING';
export const PRINT_CERTIFICATE_REJECTED = 'quote/PRINT_CERTIFICATE_REJECTED';
export const PRINT_CERTIFICATE_FULFILLED = 'quote/PRINT_CERTIFICATE_FULFILLED';

export const UPLOAD_DOCUMENT = 'quote/UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_PENDING = 'quote/UPLOAD_DOCUMENT_PENDING';
export const UPLOAD_DOCUMENT_REJECTED = 'quote/UPLOAD_DOCUMENT_REJECTED';
export const UPLOAD_DOCUMENT_FILFILLED = 'quote/UPLOAD_DOCUMENT_FULFILLED';

export const EMAIL_QUOTE = 'quote/EMAIL_QUOTE';
export const EMAIL_QUOTE_PENDING = 'quote/EMAIL_QUOTE_PENDING';
export const EMAIL_QUOTE_REJECTED = 'quote/EMAIL_QUOTE_REJECTED';
export const EMAIL_QUOTE_FULFILLED = 'quote/EMAIL_QUOTE_FULFILLED';

export const EMAIL_CERTIFICATE = 'quote/EMAIL_CERTIFICATE';
export const EMAIL_CERTIFICATE_PENDING = 'quote/EMAIL_CERTIFICATE_PENDING';
export const EMAIL_CERTIFICATE_REJECTED = 'quote/EMAIL_CERTIFICATE_REJECTED';
export const EMAIL_CERTIFICATE_FULFILLED = 'quote/EMAIL_CERTIFICATE_FULFILLED';

export const VERIFY_POLICY = 'policy/VERIFY_POLICY';
export const VERIFY_POLICY_PENDING = 'policy/VERIFY_POLICY_PENDING';
export const VERIFY_POLICY_REJECTED = 'policy/VERIFY_POLICY_REJECTED';
export const VERIFY_POLICY_FULFILLED = 'policy/VERIFY_POLICY_FULFILLED';

export const REQUEST_SELCOM = 'payment/REQUEST_SELCOM';
export const REQUEST_SELCOM_PENDING = 'payment/REQUEST_SELCOM_PENDING';
export const REQUEST_SELCOM_REJECTED = 'payment/REQUEST_SELCOM_REJECTED';
export const REQUEST_SELCOM_FULFILLED = 'payment/REQUEST_SELCOM_FULFILLED';

export const CHECK_PAYMENT_STATUS = 'payment/CHECK_PAYMENT_STATUS';
export const CHECK_PAYMENT_STATUS_PENDING =
  'payment/CHECK_PAYMENT_STATUS_PENDING';
export const CHECK_PAYMENT_STATUS_REJECTED =
  'payment/CHECK_PAYMENT_STATUS_REJECTED';
export const CHECK_PAYMENT_STATUS_FULFILLED =
  'payment/CHECK_PAYMENT_STATUS_FULFILLED';

export const listCurrencies = () => {
  const payload = getCurrencyList();
  return {
    type: LIST_CURRENCIES,
    payload
  };
};

export const listCountries = () => {
  const payload = getCountries();
  return {
    type: LIST_COUNTRIES,
    payload
  };
};

export const listConveyance = () => {
  const payload = getConveyance();
  return {
    type: LIST_CONVEYANCE,
    payload
  };
};

export const listDestinationTowns = () => {
  return {
    type: LIST_DESTINATION_TOWNS,
    payload: getDestinationTowns()
  };
};

export const listDestinationPorts = conveyance => {
  return {
    type: LIST_DESTINATION_PORTS,
    payload: getDestinationPorts(conveyance)
  };
};

export const listGoodsSections = () => {
  return {
    type: LIST_GOODS_SECTIONS,
    payload: getGoodsSections()
  };
};

export const listGoods = category => {
  return {
    type: LIST_GOODS,
    payload: getGoods()
  };
};

export function saveQuote(quote) {
  const payload = api(quote);
  return {
    type: CREATE_QUOTE,
    payload
  };
}

export function updateQuote(quote) {
  const payload = quoteUpdate(quote);
  return {
    type: UPDATE_QUOTE,
    payload
  };
}

export function uploadDocuments(docs) {
  const payload = saveDocuments(docs);
  return {
    type: UPLOAD_DOCUMENT,
    payload
  };
}

export function emailQuote(data) {
  const payload = sendQuotationEmail(data);
  return {
    type: EMAIL_QUOTE,
    payload
  };
}

export const printCert = quote => {
  const payload = printCertificate(quote);
  return {
    type: PRINT_CERTIFICATE,
    payload
  };
};

export const emailCert = (quote, receivers) => {
  const payload = emailCertificate(quote, receivers);
  return {
    type: EMAIL_CERTIFICATE,
    payload
  };
};

export const publicVerifyPolicy = policy => {
  const payload = publicPolicyVerification(policy);
  return {
    type: VERIFY_POLICY,
    payload
  };
};

export const requestToPaySelcom = quote => {
  return {
    type: REQUEST_SELCOM,
    payload: requestSelcomPayment(quote)
  };
};
export const CheckPaymentStatus = quote => {
  const payload = checkPaymentStatus(quote);
  return {
    type: CHECK_PAYMENT_STATUS,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/policy.js